module.exports = function getResource(label, vars = []) {
    const resources = {
        beautyPreferencesTitle: 'Beauty Preferences',
        beautyPreferencesDesc: 'Tell us your beauty traits and shopping preferences to get more personalized recommendations.',
        profileCompletionStatusHeading: 'Complete Your Beauty Preferences',
        profileCompleteMessageHeading: 'Thanks for sharing your preferences. You have unlocked personalized recommendations.',
        checkRecommendationsLinkHeading: 'Check out your product recommendations.',
        profileInterimMessageHeading: 'Keep going! The more you tell us the better the recommendations.',
        save: 'Save',
        saveAndContinue: 'Save and Continue',
        skipThisQues: 'Skip this question',
        signIn: 'Sign In to Save',
        confettiModalTitle: 'Keep Going!',
        confettiModalMessage: 'Keep Going! The more you tell us the better the recommendations.',
        confettiModalButton: 'Got It',
        confettiModalMessageComplete: 'Congrats! Your Beauty Preferences are complete.',
        privacySettings: 'Beauty Preferences Privacy Settings'
    };
    return resources[label];
};
